<ion-list>
	<ion-item>
		<ion-label>Authentification par empreinte digitale</ion-label>
		<ion-toggle [disabled]="!fingerprintUnlockAvailable" [(ngModel)]="fingerprintUnlockEnabled"
			(ngModelChange)="onFingerPrintAuthenticationClicked()"></ion-toggle>
	</ion-item>
</ion-list>